import { render } from "./horizontalScroll.vue?vue&type=template&id=c883f414"
import script from "./horizontalScroll.vue?vue&type=script&lang=js"
export * from "./horizontalScroll.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__